export default {
  app: {
    deviceCategories: {
      notebook: "Notebook",
      peripheralDevice: "Peripheral device",
      smartphone: "Smartphone",
      tablet: "Tablet",
      desktop: "Desktop",
      allInOne: "All in one",
      monitor: "Monitor",
    },
    categoryInfos: {
      peripheralDevice:
        "Peripheral device includes ex.<br>mice, keyboards, headphones etc...",
    },
  },
  results: {
    headerCopy: "The average carbon footprint of your devices is...",
    unitKg: "kg",
    unitTonnes: "t",
    comparisons: {
      headerCopy:
        "Doesn't say anything? What if we tell you that for roughly the same amount of carbon emissions you can...",
      flightKmTop: "...fly around the globe",
      flightKmBottom: (amount) =>
        amount.toFixed(0) === "1" ? "kilometer by airplane" : "kilometers by airplane",
      videoConferenceTop: "...videoconference for about",
      videoConferenceBottom: (amount) =>
        amount.toFixed(0) === "1" ? "hour" : "hours",
      espressosTop: "...brew",
      espressosBottom: (amount) =>
        amount.toFixed(0) === "1" ? "single espresso" : "single espressos"
    },
    trees: {
      headerCopy:
        "Alternatively, you could compensate for your impact by planting",
      treesUnit: (amount) => (amount.toFixed(0) === "1" ? "tree" : "trees"),
    },
  },
};



// WEBPACK FOOTER //
// ./src/locale/en.js